import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ErrorBoundary from '../ErrorBoundary';
import Dropdown from '../../../blocks/Dropdown';
import Button from '../../../elements/Button';
import dropdownIconSvg from '../../../icons/dropdown-down-arrow.svg';

const LanguageButton = styled(Button)`
  font-size: 0.625rem;
  color: ${(props) => props.theme.palette.text};
`;

const LanguageListWrap = styled(Dropdown.ListWrap)`
  max-height: 220px;
  overflow: auto;
`;

const LanguageListItem = styled(Dropdown.ListItem)`
  font-weight: normal;
  text-align: left;
  font-size: 0.75rem;
`;

const Icon = styled.img`
  width: 4px;
  height: 4px;
  display: inline-block;
  transform: translateY(-2px) rotate(180deg);
  margin-left: 0.25rem;
`;

class LanguageSelector extends React.PureComponent {
  state = {
    open: false,
  };

  _handleItemClick = (language) => {
    const { _languageSelectHandler } = this.props;

    this.setState({ open: false });
    _languageSelectHandler(language.lang);
  };

  _openList = () => {
    this.setState((prevState) => ({
      open: !prevState.open,
    }));
  };

  _populateList = (languages) => languages.map((language) => (
    <LanguageListItem
      key={language.name}
      onClick={() => {
        this._handleItemClick(language);
      }}
    >
      {language.name}
    </LanguageListItem>
  ));

  _getLanguageName = (lang) => {
    const { languagesArray } = this.props;
    const currentLang = lang || 'en';

    return languagesArray.find((language) => language.lang === currentLang).name;
  }

  render() {
    const { languagesArray, currentLang } = this.props;
    const { open } = this.state;

    return (
      <ErrorBoundary>
        <Dropdown>
          <LanguageButton modifiers={['plain']} onClick={this._openList}>
            {this._getLanguageName(currentLang)}
            <Icon src={dropdownIconSvg} />
          </LanguageButton>
          <LanguageListWrap
            open={open}
            modifiers={['up']}
          >
            {this._populateList(languagesArray)}
          </LanguageListWrap>
        </Dropdown>
      </ErrorBoundary>
    );
  }
}

LanguageSelector.propTypes = {
  _languageSelectHandler: PropTypes.func.isRequired,
  currentLang: PropTypes.string.isRequired,
  languagesArray: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      lang: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default LanguageSelector;
